import i18next from 'i18n'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

/** Error code returned by the API when an action targets an ended trade show (name of the backend AppError). */
export const TRADESHOW_ENDED_ERROR_CODE = 'TradeShowEndedException'

/**
 * A trade show is ended once 24h have passed since its endDate.
 * endDate is the local midnight that starts the last show day (date picker value),
 * so endDate + 24h is the end of the last day, with no timezone involved.
 */
export function isTradeshowEnded(tradeshow: { endDate: Date }, now: Date = new Date()): boolean {
  return now.getTime() >= tradeshow.endDate.getTime() + ONE_DAY_MS
}

export function isTradeshowEndedError(error: any): boolean {
  return error?.response?.data?.code === TRADESHOW_ENDED_ERROR_CODE
}

/** Message to display for a failed API call: localized for the ended trade show error, the raw message otherwise. */
export function getApiErrorMessage(error: any): string | undefined {
  if (isTradeshowEndedError(error)) {
    return i18next.t('tradeshow.ended-error') as string
  }

  return error?.message
}
